import { Route } from 'react-router-dom';

import { withSentryRouting } from '@sentry/react';

export const SentryRoute = withSentryRouting(Route);
